// Hằng số dùng chung cho tính năng Lịch đào tạo

// Danh sách chủ đề đào tạo có sẵn (vẫn cho phép nhập tự do)
export const TRAINING_TOPICS = [
	'Chăm sóc khách hàng thực tế như thế nào trong 1 tuần liên tục',
	'Tại sao cần chăm sóc khách hàng qua zalo, cách chăm sóc cụ thể',
	'Vẽ lại giao diện khác hoàn toàn ví dụ web khách hàng thực tế',
	'Hướng dẫn vẽ giao diện theo ngành nghề',
	'Thực tập báo giá host 20gb',
	'Test kỹ năng tư vấn chức năng nâng cao',
	'Test kỹ năng gọi điện lần 2 3 4 Và xử lý từ chối hẹn',
	'Hướng dẫn quy chuẩn thiết kế website',
	'File đường đi của khách hàng, ux ui',
	'Đào tạo kiến thức Host chuyên sâu',
	'Hướng dẫn xử lý từ chối về host, giá cả...',
	'Các câu nói trong tư vấn, xử lý từ chối trong tư vấn',
	'Kiến thức chức năng nâng cao',
	'Công cụ tư vấn & hướng dẫn sử dụng',
];

// Phòng đào tạo vật lý — trừ "tai_cho", các phòng khác không cho trùng thời gian
export const ROOM_OPTIONS = [
	{value: 'tai_cho',   label: 'Đào tạo tại chỗ'},
	{value: 'phong_hop', label: 'Phòng hợp'},
	{value: 'cam_trong', label: 'Cam trong'},
	{value: 'cam_ngoai', label: 'Cam ngoài'},
];

export const ROOM_LABELS = ROOM_OPTIONS.reduce((acc, r) => {
	acc[r.value] = r.label;
	return acc;
}, {});

// Nhóm nhân viên cho "Theo người chỉ định" — chọn nhóm sẽ tự lấy NV thỏa điều kiện
export const DESIGNEE_GROUP_OPTIONS = [
	{value: 'new_3w',          label: 'Nhân viên mới (dưới 3 tuần)'},
	{value: 'new_1m',          label: 'Nhân viên mới (dưới 1 tháng)'},
	{value: 'new_2m',          label: 'Nhân viên mới (dưới 2 tháng)'},
	{value: 'low_consult',     label: 'Nhân viên ít tư vấn'},
	{value: 'low_appointment', label: 'Nhân viên ít hẹn'},
	{value: 'low_both',        label: 'Nhân viên ít tư vấn và ít hẹn'},
];
